import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// components
import PaymentMessage from '../../Message';

const RootStyle = styled('div')(({ theme }) => ({
  marginBottom: '16px',
  borderRadius: '16px',
  marginTop: theme.spacing(3),
  padding: theme.spacing(3),
  border: `1px dashed ${grey[300]}`
}));

PaymentMethodSibsMBWay.propTypes = {
  payment: PropTypes.object
};

export default function PaymentMethodSibsMBWay({ payment }) {
  return (
    <RootStyle>
      <Box sx={{ textAlign: 'center' }}>
        <PaymentMessage payment={payment} />
        <Box
          sx={{ display: 'inline-block' }}
          src="/static/payment/logo-mbway.svg"
          component="img"
          height={40}
        />
      </Box>
    </RootStyle>
  );
}
